import script from "./Co2AverageForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2AverageForm.vue?vue&type=script&lang=ts&setup=true"

import "./Co2AverageForm.vue?vue&type=style&index=0&id=3affcc24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3affcc24"]])

export default __exports__